import { render, staticRenderFns } from "./add_edit.vue?vue&type=template&id=c109a922&scoped=true&"
import script from "./add_edit.vue?vue&type=script&lang=js&"
export * from "./add_edit.vue?vue&type=script&lang=js&"
import style0 from "./add_edit.vue?vue&type=style&index=0&id=c109a922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c109a922",
  null
  
)

export default component.exports